/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import nestAxios from 'services/_nestAxios'
import inveAxios from 'services/_inveAxios'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import { setupNestAxios, setupInveAxios } from '_metronic'
import store, { persistor } from 'store/store'
import App from './App'
import './index.scss' // Standard version
import '_zari/core/index.scss'
import '_zari/core/main.scss'
// import "./sass/style.react.rtl.css"; // RTL version
import 'socicon/css/socicon.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '_metronic/_assets/plugins/line-awesome/css/line-awesome.css'
import '_metronic/_assets/plugins/flaticon/flaticon.css'
import '_metronic/_assets/plugins/flaticon2/flaticon.css'
import 'react-datepicker/dist/react-datepicker.css'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupNestAxios(nestAxios, store)
setupInveAxios(inveAxios)

registerLocale('es', es)
setDefaultLocale('es')

ReactDOM.render(<App store={store} persistor={persistor} basename={PUBLIC_URL} />, document.getElementById('root'))
